/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LineToNextPoint/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function LineToNextPoint({
  children,
  viewPath = "/DesignSystem/AppointmentHistory/Content/Entry/LineToNextPoint"
  
}) {
let entryItemIsLastValueData = fromData.useDataFormat({ viewPath,
context: 'entry_item',
path: 'isLast',
format: fromFormat.not,
})
let entryActionValueData = fromData.useDataValue({ viewPath,
context: 'entry',
path: 'action',
})
let constantData = 'NO_SHOW'
let aggregateData = fromAggregate.equals(entryActionValueData, constantData)
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<fromFlow.When is={entryItemIsLastValueData}>
<div
  data-testid="LineToNextPoint.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-1P8e5D': dtColorsNeutral400,'--mh-2-1P8e5D': aggregateData ? "70px" : "50px"}}
 className={`views-block ${styles.Horizontal}`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}